import React, { useState, useEffect } from "react";
import Api from "../../components/api/Api";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import Notification, {
  showToast,
} from "../../../components/common/notification/Notification";
// eslint-disable-next-line no-unused-vars
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../../components/common/spinner/Spinner";
import { useSelector } from "react-redux";
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";

const EditUserType = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  // eslint-disable-next-line no-unused-vars
  const userId = loggedInUser?.userDetails?.id;
  const navigate = useNavigate();
  const { userTypeId } = useParams();

  const editPostApi = Api({
    url: `admin/editUserType`,
  });

  const getAllUserTypeApi = Api({
    url: `admin/userTypes`,
  });

  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isError, setIsError] = useState(false);
  const [selectedUserType, setSetelectedUserType] = useState("");
  const getUserTypeApi = Api({
    url: `admin/userType/${selectedUserType}`,
  });
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  useEffect(() => {
    const getPurposes = async () => {
      try {
        const responseData = await getAllUserTypeApi.fetchData();
        if (responseData.data.statusType === "SUCCESS") {
          const purposeData = await responseData.data.userTypes.filter(
            (data) => data.id === +userTypeId
          );
          setSetelectedUserType(purposeData[0]?.name);
          console.log(purposeData);
        }
      } catch (error) {
        console.error(error);
      }
    };
    const fetchPostData = async () => {
      try {
        setIsLoading(true);
        const response = await getUserTypeApi.fetchDataBySingleId(true);
        if (response?.data?.statusType === "SUCCESS") {
          const postData = response.data.userType;
          console.log(postData.name);

          setFormData({
            name: postData.name,
            description: postData.description,
          });
        }
      } catch (error) {
        setIsError(true);
        console.error(error);
        showToast("Error Occurred", { type: "error" });
      } finally {
        setIsLoading(false);
      }
    };

    getPurposes();
    fetchPostData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUserType]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      setIsLoading(true);
      const data = {
        id: userTypeId,
        title: formData.name,
        description: formData.description,
      };
      console.log(data);

      const responseData = await editPostApi.editData(data);
      if (responseData.data.statusType === "SUCCESS") {
        showToast("User Type updated successfully", { type: "success" });
        setTimeout(() => {
          navigate("/user-type");
        }, 3000);
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
      showToast("Error Occurred", { type: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Master", link: "/user" },
    { label: "User Types", link: "/user-type", active: true },
    { label: "Edit User Type", link: "", active: true },
  ];
  return (
    <>
      <Notification />
      <Container fluid style={{ marginTop: "2rem", padding: "0rem 4rem" }}>
        <BreadCrumb items={breadcrumbItems} />
        <Row>
          <Col lg={12} md={12} sm={12}>
            <SingleDetailHeader
              header="Edit User Type Details"
              description="Edit user type details section"
            />
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <div className="mb-3">
                    <label htmlFor="title" className="form-label">
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="title"
                      placeholder="Enter Name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                    />
                  </div>
                </Col>
                <Col>
                  <div className="mb-3">
                    <label htmlFor="description" className="form-label">
                      Description
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="description"
                      placeholder="Enter Description"
                      name="description"
                      value={formData.description}
                      onChange={handleInputChange}
                    />
                  </div>
                </Col>
              </Row>

              <Button variant="primary" type="submit" className="mt-5 mb-5">
                {isLoading ? <Spinner loading={true} /> : "Edit User Type"}
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EditUserType;
